'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface SocialShareProps {
  className?: string;
}

const SocialShare: React.FC<SocialShareProps> = ({ className = '' }) => {
  const socialPlatforms = [
    { name: 'Facebook', icon: 'ShareIcon', color: 'hover:bg-[#1877F2] hover:text-white' },
    { name: 'Twitter', icon: 'ShareIcon', color: 'hover:bg-[#1DA1F2] hover:text-white' },
    { name: 'LinkedIn', icon: 'ShareIcon', color: 'hover:bg-[#0A66C2] hover:text-white' },
    { name: 'Email', icon: 'EnvelopeIcon', color: 'hover:bg-sunset-orange hover:text-white' },
  ];

  return (
    <div data-component-id="src/app/news-updates/components/SocialShare.tsx:19:4" data-component-path="src/app/news-updates/components/SocialShare.tsx" data-component-line="19" data-component-file="SocialShare.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`bg-card border border-border rounded-lg p-6 shadow-minimal ${className}`}>
      <h3 data-component-id="src/app/news-updates/components/SocialShare.tsx:20:6" data-component-path="src/app/news-updates/components/SocialShare.tsx" data-component-line="20" data-component-file="SocialShare.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22Podijelite%22%7D" className="text-lg font-semibold text-foreground mb-4">Podijelite</h3>
      <div data-component-id="src/app/news-updates/components/SocialShare.tsx:21:6" data-component-path="src/app/news-updates/components/SocialShare.tsx" data-component-line="21" data-component-file="SocialShare.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-2%22%7D" className="flex flex-wrap gap-2">
        {socialPlatforms.map((platform) => (
          <button data-component-id="src/app/news-updates/components/SocialShare.tsx:23:10" data-component-path="src/app/news-updates/components/SocialShare.tsx" data-component-line="23" data-component-file="SocialShare.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={platform.name}
            className={`flex items-center justify-center w-10 h-10 rounded-lg bg-muted text-muted-foreground transition-smooth ${platform.color}`}
            aria-label={`Podijelite na ${platform.name}`}
          >
            <Icon data-component-id="src/app/news-updates/components/SocialShare.tsx:28:12" data-component-path="src/app/news-updates/components/SocialShare.tsx" data-component-line="28" data-component-file="SocialShare.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={platform.icon as any} size={20} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default SocialShare;